import React, { useEffect, useRef, useState } from "react";
import { TextField, TextFieldProps } from "@mui/material";

export default function AutoSizeTextField(props: TextFieldProps) {
  const [width, setWidth] = useState(1);
  const spanRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (spanRef.current) {
      setWidth(spanRef.current.offsetWidth + 20); // padding
    }
  }, [props.value]);

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <span
        ref={spanRef}
        style={{
          position: "absolute",
          visibility: "hidden",
          whiteSpace: "pre",
          font: "inherit",
        }}
      >
        {/*@ts-ignore*/}
        {props.value?.toString() || " "}
      </span>
      <TextField
        {...props}
        sx={{
          ...props.sx, // spread original sx
          "& .MuiInputBase-input": {
            // @ts-ignore
            ...(props.sx?.["& .MuiInputBase-input"] || {}), // preserve nested rules
            width: `${width}px`, // override/add width
          },
        }}
      />
    </div>
  );
}
